import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

/** retryable = ปัญหาชั่วคราว (ต่อ AD/API ไม่ได้, เครือข่ายล่ม) ให้ลองใหม่ ไม่ใช่รหัสผิด */
interface LoginError {
  message: string;
  retryable: boolean;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  form = this._fb.nonNullable.group({
    username: '',
    password: '',
  });
  loading: boolean = false;
  showPassword: boolean = false;
  error: LoginError | null = null;

  constructor(
    private _fb: FormBuilder,
    private _auth: AuthService,
    private _router: Router,
    private _route: ActivatedRoute
  ) { }

  submit() {
    if (this.loading) return;
    const { username, password } = this.form.getRawValue();
    if (!username.trim() || !password) {
      this.error = { message: 'กรุณากรอกชื่อผู้ใช้และรหัสผ่าน', retryable: false };
      return;
    }

    this.setLoading(true);
    this.error = null;
    this._auth.login(username.trim(), password).subscribe({
      next: () => this._router.navigateByUrl(this.redirectUrl()),
      error: (err: HttpErrorResponse) => {
        this.error = {
          message: err.error?.message
            || (err.status === 0 ? 'เชื่อมต่อเซิร์ฟเวอร์ไม่ได้ กรุณาตรวจสอบเครือข่ายแล้วลองใหม่' : 'เข้าสู่ระบบไม่สำเร็จ กรุณาลองใหม่'),
          retryable: err.status === 0 || err.status >= 500,
        };
        // ล้างรหัสเฉพาะกรณีรหัสผิด — AD ล่มชั่วคราวให้กดลองใหม่ได้เลย
        if (err.status === 401) this.form.controls.password.reset();
        this.setLoading(false);
      }
    });
  }

  private setLoading(loading: boolean) {
    this.loading = loading;
    if (loading) this.form.disable();
    else this.form.enable();
  }

  /** กลับไปหน้าที่เปิดไว้ก่อน login — รับเฉพาะ path ภายในระบบ */
  private redirectUrl(): string {
    const redirect = this._route.snapshot.queryParamMap.get('redirect') || '';
    return redirect.startsWith('/') && !redirect.startsWith('//') ? redirect : '/';
  }
}
